import { translation } from "../../helper/translation"

export const PartialPrivacyPolicy = () => {
    return (
        <div>
             <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-12">
                        <h1 className="mb-4">{translation('privacy-policy')}</h1>
                        <div className="datenschutz-content">
                            <h2>Datenschutz auf einen Blick</h2>
                            <br />
                            <h4>Allgemeine Hinweise</h4>
                            <br />
                            <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten
passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen
Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.</p>
                            <br />
                            <h4>Datenerfassung auf dieser Website</h4>
                            <br />
                            <p>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</p>
                            <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.</p>
                            <br />
                            <p>Wie erfassen wir Ihre Daten?</p>
                            <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</p>
                            <p>Andere Daten werden automatisch oder nach Ihrer Einwilligung erhoben, wenn Sie unsere Website besuchen, indem der eingebundene Browser mitunter Dateien (so genannte Cookies) auf Ihrem Endgerät speichert.</p>
                            <br />
                            <p>Welche Daten werden erhoben?</p>
                            <p>Unter anderem werden Daten erhoben, um eine Verbindung zum Server herzustellen, die notwendig ist, um Inhalte auszutauschen, die Sie anfordern, und Nutzungsdaten zu erheben.</p>
                            <br />
                            <p>Wie werden Ihre Daten verarbeitet?</p>
                            <p>Alle Daten werden zur Erfüllung von Vertragsverpflichtungen und zum Schutzzweck verarbeitet. Wir geben Ihre Daten ohne Ihre Einwilligung nicht an Dritte weiter.</p>
                            <br />
                            <p>Welche Rechte haben Sie bezüglich Ihrer Daten?</p>
                            <p>Sie haben jederzeit das Recht, unbeantragt Informationen zu Ihrer Person zu löschen. Zusätzlich haben Sie das Recht, die Berichtigung, Sperrung oder Löschung Ihrer personenbezogenen Daten zu verlangen.</p>
                            <br />
                            <p>Widerspruchsrecht</p>
                            <p>Sie können der künftigen Verarbeitung Ihrer personenbezogenen Daten nachfolgenden Widerspruch erklären. In diesem Fall werden die personenbezogenen Daten nach der Widerspruchserklärung nicht mehr verarbeitet.</p>
                            <br />
                            <h2>Hosting</h2>
                            <br />
                            <p>Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>
                            <br />
                            <h4>Externes Hosting</h4>
                            <br />
                            <p>Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden,
werden auf den Servern des Hosters / der Hoster gespeichert. Hierbei kann es sich v. a. um IP-Adressen,
Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe
und sonstige Daten, die über eine Website generiert werden, handeln.</p>
                            <p>Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und
bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten
Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf
Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung
von Cookies oder den Zugriff auf Informationen im Endgerät des Nutzers (z. B. Device-Fingerprinting) im
Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.</p>
                            <p>Unser(e) Hoster wird bzw. werden Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung seiner
                            Leistungspflichten erforderlich ist und unsere Weisungen in Bezug auf diese Daten befolgen.</p>
                            <br />
                            <p>Wir setzen folgende(n) Hoster ein:</p>
                            <br />
                            <p>Aerotek Bilişim Sanayi ve Ticaret AŞ.</p>
                            <p>Sanayi Mah. Koza Sok. No: 10 Blok: F6 Çarşı Yapı Posta Kodu: 41040 İzmit / Kocaeli / Türkiye</p>

                            <br />
                            <h2>Allgemeine Hinweise und Pflichtinformationen</h2>
                            <br />
                            <h4>Datenschutz</h4>
                            <br />
                            <p>Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.</p>
                            <br />
                            <p>Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.</p>
                            <br />
                            <p>Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail)
Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
möglich.</p>
                            <br />
                            <h4>Hinweis zur verantwortlichen Stelle</h4>
                            <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
                            <br />
                            <p>Engin Kaya</p>
                            <p>Engin Kaya</p>
                            <p>Hofzeile 10-12/6/7</p>
                            <p>1190 Wien</p>
                            <p>Österreich</p>
                            <br />
                            <p>Telefon: +43 699 10646156</p>
                            <p>E-Mail: ek@enginkaya.com</p>
                            <br />
                            <p>Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über
die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.)
entscheidet.</p>
                            <br />
                            <h4>Speicherdauer</h4>
                            <br />
                            <p>Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben
Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein
berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen,
werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im
letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe</p>
                            <br />
                            <h4>Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser
                            Website</h4>
                            <br />
                            <p>Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten auf
Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien
nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle einer ausdrücklichen Einwilligung in die Übertragung
personenbezogener Daten in Drittstaaten erfolgt die Datenverarbeitung außerdem auf Grundlage von Art.
49 Abs. 1 lit. a DSGVO. Sofern Sie in die Speicherung von Cookies oder in den Zugriff auf Informationen in
Ihr Endgerät (z. B. via Device-Fingerprinting) eingewilligt haben, erfolgt die Datenverarbeitung zusätzlich
auf Grundlage von § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen erforderlich, verarbeiten wir Ihre
Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese
zur Erfüllung einer rechtlichen Verpflichtung erforderlich sind auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO.
Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f
DSGVO erfolgen. Über die jeweils im Einzelfall einschlägigen Rechtsgrundlagen wird in den folgenden
Absätzen dieser Datenschutzerklärung informiert.</p>
                            <br />
                            <h4>Empfänger von personenbezogenen Daten</h4>
                            <br />
                            <p>Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen externen Stellen zusammen. Dabei
ist teilweise auch eine Übermittlung von personenbezogenen Daten an diese externen Stellen erforderlich.
Wir geben personenbezogene Daten nur dann an externe Stellen weiter, wenn dies im Rahmen einer
Vertragserfüllung erforderlich ist, wenn wir gesetzlich hierzu verpflichtet sind (z. B. Weitergabe von Daten
an Steuerbehörden), wenn wir ein berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der Weitergabe
haben oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von
Auftragsverarbeitern geben wir personenbezogene Daten unserer Kunden nur auf Grundlage eines gültigen
Vertrags über Auftragsverarbeitung weiter. Im Falle einer gemeinsamen Verarbeitung wird ein Vertrag über
gemeinsame Verarbeitung geschlossen.</p>
                            <br />
                            <h4>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h4>
                            <br />
                            <p>Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine
bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
Datenverarbeitung bleibt vom Widerruf unberührt.</p>
                            <br />
                            <h4>Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen
                            Direktwerbung (Art. 21 DSGVO)</h4>
                            <br />
                            <p>WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO
ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN
SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN
WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES
PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT,
ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN,
WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES
SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG
NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN ODER DIE
VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON
RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).</p>
<br />
                            <p>WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN,
SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE
BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG
EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN
VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN
ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH
NACH ART. 21 ABS. 2 DSGVO).</p>
<br />
                            <h4>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h4>
                            <br />
                            <p>Als Betroffener steht Ihnen das Recht zu, sich bei einer Aufsichtsbehörde zu beschweren. In Österreich ist dies die
                            Datenschutzbehörde.</p>
                            <br />
                            <h4>Auskunft, Berichtigung und Löschung</h4>
                            <br />
                            <p>Sie haben jederzeit das Recht, unbeantragt Informationen zu Ihrer Person zu löschen. Zusätzlich haben Sie das Recht, die Berichtigung, Sperrung oder Löschung Ihrer personenbezogenen Daten zu verlangen.</p>
                            <br />
                            <h4>Recht auf Einschränkung der Verarbeitung</h4>
                            <br />
                            <p>Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
Hierzu können Sie sich jederzeit an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in
folgenden Fällen:</p>
                            <br />
                            <p>Wenn Sie die Richtigkeit Ihrer personenbezogenen Daten bestreiten, benötigen wir eine angemessene Frist,
in der wir die Richtigkeit der Daten überprüfen können.</p>
                            <br />
                            <p>Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig ist, können Sie die Löschung
Ihrer Daten verlangen.</p>
                            <br />
                            <p>Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung,
Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt der
Löschung die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.</p>
<br />  
                            <p>Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen
Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen
überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten
zu verlangen.</p>
                            <br />
                            <p>Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von
ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder
Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder
juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der Europäischen Union oder
eines Mitgliedstaats verarbeitet werden.</p>
                        </div>
                        <br />
                        <h4>SSL- bzw. TLS-Verschlüsselung</h4>
                        <br />
                        <p>Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum
Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-
Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von
„http://“ auf „https://“ wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.</p>
                        <br />
                        <p>Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht
                        von Dritten mitgelesen werden.</p>
                        <br />
                        <h4>Datenerfassung auf dieser Website</h4>
                        <br />
                        <h4>Cookies</h4>
                        <br />
                        <p>Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Datenpakete und richten auf
Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung
(Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies
werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät
gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.</p>
                        <br />
                        <p>Cookies können von uns (First-Party-Cookies) oder von Drittunternehmen stammen (sog. Third-Party-
Cookies). Third-Party-Cookies ermöglichen die Einbindung bestimmter Dienstleistungen von
Drittunternehmen innerhalb von Webseiten (z. B. Cookies zur Abwicklung von Zahlungsdienstleistungen).</p>
<br />
                        <p>Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte
Webseitenfunktionen ohne diese nicht funktionieren würden (z. B. die Warenkorbfunktion oder die Anzeige
von Videos). Andere Cookies können zur Auswertung des Nutzerverhaltens oder zu Werbezwecken
verwendet werden.</p>
                        <br />
                        <p>Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs, zur Bereitstellung
bestimmter, von Ihnen erwünschter Funktionen (z. B. für die Warenkorbfunktion) oder zur Optimierung der
Website (z. B. Cookies zur Messung des Webpublikums) erforderlich sind (notwendige Cookies), werden auf
Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere Rechtsgrundlage angegeben wird.
Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von notwendigen Cookies zur
technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung zur
Speicherung von Cookies und vergleichbaren Wiedererkennungstechnologien abgefragt wurde, erfolgt die
Verarbeitung ausschließlich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1
TDDDG); die Einwilligung ist jederzeit widerrufbar.</p>
                        <br />
                        <p>Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und
Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen
sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren. Bei der
Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.</p>
<br />
                        <p>Welche Cookies und Dienste auf dieser Website eingesetzt werden, können Sie dieser
                        Datenschutzerklärung entnehmen.</p>
                        <br />
                        <h2>Plugins und Tools</h2>
                        <br />
                        <h4>Google Fonts (lokales Hosting)</h4>
                        <br />
                        <p>Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Google Fonts, die von Google
bereitgestellt werden. Die Google Fonts sind lokal installiert. Eine Verbindung zu Servern von Google findet
dabei nicht statt.</p>
                        <br />
                        <p>Weitere Informationen zu Google Fonts finden Sie unter
https://developers.google.com/fonts/faq und in der Datenschutzerklärung von Google:
https://policies.google.com/privacy?hl=de.</p>
                        <br />
                        <h4>Font Awesome (lokales Hosting)</h4>
                        <br />
                        <p>Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten Font Awesome. Font Awesome ist lokal
                        installiert. Eine Verbindung zu Servern von Fonticons, Inc. findet dabei nicht statt.</p>
                        <br />
                        <p>Weitere Informationen finden Sie in der Datenschutzerklärung von Font Awesome:
https://fontawesome.com/privacy.</p>
                        <br />
                        <h4>Google reCAPTCHA</h4>
                        <br />
                        <p>Wir nutzen „Google reCAPTCHA“ (im Folgenden „reCAPTCHA“) auf dieser Website. Anbieter ist die Google
                        Ireland Limited („Google“), Gordon House, Barrow Street, Dublin 4, Irland.</p>
                        <br />
                        <p>Mit reCAPTCHA soll der Schutz vor Spam und der Schutz vor Missbrauch durch Maschinen erhöht werden.
                        Weitere Informationen zu reCAPTCHA finden Sie auf
https://www.google.com/intl/de/policies/privacy/.</p>
                        <br />
                        <p>Mit reCAPTCHA soll überprüft werden, ob die Dateneingabe auf dieser Website (z. B. in einem
Kontaktformular) durch einen Menschen oder durch ein automatisiertes Programm erfolgt. Hierzu
analysiert reCAPTCHA das Verhalten des Websitebesuchers anhand verschiedener Merkmale. Diese
Analyse beginnt automatisch, sobald der Websitebesucher die Website betritt. Zur Analyse wertet
reCAPTCHA verschiedene Informationen aus (z. B. IP-Adresse, Verweildauer des Websitebesuchers auf der
Website oder vom Nutzer getätigte Mausbewegungen). Die bei der Analyse erfassten Daten werden an
Google weitergeleitet.</p>
<br />
                        <p>Die reCAPTCHA-Analysen laufen vollständig im Hintergrund. Websitebesucher werden nicht darauf
                        hingewiesen, dass eine Analyse stattfindet.</p>
                        <br />
                        <p>Die Speicherung und Analyse der Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der
Websitebetreiber hat ein berechtigtes Interesse daran, seine Webangebote vor missbräuchlicher
automatisierter Ausspähung und vor SPAM zu schützen. Sofern eine entsprechende Einwilligung abgefragt
wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1
TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im
Endgerät des Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist
jederzeit widerrufbar.</p>
<br />
                        <p>Weitere Informationen zu Google reCAPTCHA entnehmen Sie den Google-Datenschutzbestimmungen und
den Google Nutzungsbedingungen unter folgenden Links:
https://policies.google.com/privacy?hl=de und
https://policies.google.com/terms?hl=de.</p>
                        <br />
                        <p>Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US Data Privacy Framework“ (DPF). Der
DPF ist ein Übereinkommen zwischen der Europäischen Union und den USA, der die Einhaltung
europäischer Datenschutzstandards bei Datenverarbeitungen in den USA gewährleisten soll. Jedes nach
dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere
Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link:
https://www.dataprivacyframework.gov/participant/5780.</p>
<br />
                        <p>Quelle: https://www.e-recht24.de</p>
                    </div>
                </div>
            </div>
        </div>
    )
}